import React from 'react'

const Navbar = () => {
  return (
    <div className='bg-[#FCFCFC] shadow-md px-[40px] lg:px-[63px] py-4 md:py-5 z-[9999]  fixed top-0 left-0 right-0   flex justify-center md:justify-between items-center'>



        <img src="./asset/logo.png" className="h-[37px] md:h-[46px] lg:h-[55px]" alt='' />

        <div className='md:flex items-center gap-[24px] lg:gap-[48px] hidden '>
           <a href='#service'> <p className='text-[18px] lg:text-[20px] text-[#140152]'>our services</p></a>
           <a href='#contact'>   <p className='text-[18px] lg:text-[20px] text-[#140152]'>contact us</p></a>
        </div>
    </div>

  )
}

export default Navbar